import { genericHandlerError, getWithAxios } from '../../services/commonServices';
import store from '../../store';
import { LocationByRegion } from './location.types';

export const locationActionsTypes = {
  SET_LOCATIONS: 'SET_LOCATIONS',
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_LOCATIONS_WITH_RESIDENTS: 'SET_LOCATIONS_WITH_RESIDENTS',
  SET_IS_LOADING_WITH_RESIDENTS: 'SET_IS_LOADING_WITH_RESIDENTS'
};

const setLocations = (locationsByRegion: Array<LocationByRegion>) => {
  return {
    type: locationActionsTypes.SET_LOCATIONS,
    data: locationsByRegion
  };
};

const setLocationsWithResidents = (locations: Array<{ Name: string; Residents: string }>) => {
  return {
    type: locationActionsTypes.SET_LOCATIONS_WITH_RESIDENTS,
    data: locations
  };
};
const setIsLoading = () => {
  return {
    type: locationActionsTypes.SET_IS_LOADING
  };
};
const setIsLoadingWithResidents = () => {
  return {
    type: locationActionsTypes.SET_IS_LOADING_WITH_RESIDENTS
  };
};

export const getLocations = () => {
  return (dispatch: any) => {
    if (!store.getState().locationsState.isLoading) {
      dispatch(setIsLoading());
      getWithAxios('/destinationcontinents')
        .then((locations: any) => {
          locations.data.map((region: any) => region?.Locations?.sort())
          dispatch(setLocations(locations.data.sort((a: LocationByRegion, b: LocationByRegion) => (a.Region < b.Region ? -1 : a.Region === b.Region ? 0 : 1))));
        })
        .catch(genericHandlerError);
    }
  };
};

export const getLocationsWithResidents = () => {
  return (dispatch: any) => {
    if (!store.getState().locationsState.isLoadingWithResidents) {
      dispatch(setIsLoadingWithResidents());
      getWithAxios('/detaileddestinations')
        .then((locations: any) => {
          dispatch(setLocationsWithResidents(locations.data.sort((a: any, b: any) => (a.Name > b.Name ? 1 : -1))));
        })
        .catch(genericHandlerError);
    }
  };
};
